import { AvtaleGiroAction, AvtaleGiroActionType } from './actions';
import { avtalegiroInitialState, AvtaleGiroState } from './state';

const avtalegiroReducer = (state: AvtaleGiroState, action: AvtaleGiroAction): AvtaleGiroState => {
    switch (action.type) {
        case AvtaleGiroActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case AvtaleGiroActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case AvtaleGiroActionType.SET_KID:
            return {
                ...state,
                kid: action.payload,
            };
        case AvtaleGiroActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case AvtaleGiroActionType.TRANSACTION_AMOUNT_LIMIT:
            return {
                ...state,
                transactionLimit: action.payload,
            };
        case AvtaleGiroActionType.MONTHLY_AMOUNT_LIMIT:
            return {
                ...state,
                monthlyLimit: action.payload ?? 0,
            };
        case AvtaleGiroActionType.RESET:
            return {
                ...avtalegiroInitialState,
            };
        case AvtaleGiroActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case AvtaleGiroActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        default:
            return state;
    }
};

export default avtalegiroReducer;
